import { call, put, delay } from "redux-saga/effects";
import { toast } from "react-toastify";
import { login_success, logout_success, register } from "../actions";
import { updateProfile } from "../../firebase/methods";
import { getCategory, getSubcategory, setRegisterUser } from '../../redux/actions'
import { SET_REGISTERED_USER } from '../../redux/actions/types'
import { registeration, sign_in, forgotpassword } from "../../backend/user"
import axios from 'axios'
import Cookies from 'js-cookie'


// import { show_loader, hide_loader } from "../actions";
// import { browserHistory } from 'react-router'
// import {updateProfile} from "../firebase/methods";
// import { setCookies } from '../utilities/auth-helpers';
// import cookie from "js-cookie";
// import { setProductUrlCookie } from "../utilities/auth-helpers";
// import axiosInstance from "../../utilities/axios-instance";
// import { signIn, getIdToken, getUserInformation, createUserProfileDocument, sendVerificationEmail, sendResetPasswordEmail, } from "../../firebase/auth";


export function* logout() {
  Cookies.remove('token')
  yield put(logout_success());
}

export function* login({ payload: { values: { email, password }, remember, history: history, callback, }, }) {
  try {
    // yield put(show_loader());
    const response = yield call(sign_in, { email, password });
    console.log(response);
    if (response.data.success == true) {
      if (remember)
        Cookies.set('token', response.data.token, { expires: 30 });
      else
        Cookies.set('token', response.data.token, { expires: 1 });
      yield put(login_success(response));
      yield put(getCategory())
      yield put(getSubcategory())
      history.push('/dashboard')
      toast.success(response.data.message);
    }
    else if (response.data.success == false) {
      toast.error(response.data.message);
    }
    callback()

  } catch (error) {

    if (callback) callback();
    console.log(error)
    toast.error(error.message);
  }
}











export function* registered_proceed(payload) {
  try {
    //   yield put(showLoader());
    const response = yield call(registeration, payload.payload.data)
    // alert(JSON.stringify(response.data.success))
    if (response.data.success) {
      yield put(register(payload.payload));
      toast.success(response.data.message);
      payload.payload.history.push('/login');

    }
    else {
      toast.error(response.data.message);
    }
    payload.payload.callback();
  } catch (error) {
    if (payload.payload.callback)
      payload.payload.callback();
    //  yield put(registerFailure(error));

    toast.error(error.message);
    //  yield put(hideLoader());
  }

}




export function* forgotPasswordHandler(details) {


  try {
    //  alert('yes')
    const response = yield call(forgotpassword, { email: details.payload.values.email })
    // yield put(showLoader());
    console.log(response)
    if (response.data.success) {
      toast.success(response.data.message);
      details.payload.history.push("/mail-sent");
    }
    else {
      toast.error(response.data.message);
    }
    details.payload.callback();
  }
  catch (error) {
    toast.error(error.message);
    details.payload.callback();
    //   yield put(hideLoader());
  }
}



const requestGetRegisterUser = (data) => {
  return axios.request({
    method: 'post',
    data,
    headers: {
      'Content-Type': 'application/json',
      'Authorization': Cookies.get('token')
    },
    url: `${process.env.REACT_APP_SERVER_URL}/v1/users/all-register-user`
  })
}


export function* fetchRegisterUser(action) {
  const { skip, limit, callback, searchWords, searchflag } = action.payload;
  try {
    const response = yield call(requestGetRegisterUser, { skip: skip, limit: limit, search: searchWords, searchflag: searchflag })
    //  yield put(setRegisterUser,{users:response.data.users})
    yield put({
      type: SET_REGISTERED_USER,
      payload: { users: response.data.users, size: response.data.unSkippedSize },
    })
    // toast.success("Get All Register User!");
    callback()
  }
  catch (error) {
    if (callback)
      callback();
    toast.error(error.message);

  }
}







// function* User() {
//   yield all([takeLatest(logout, saga_logout),
//     takeLatest(login, saga_login),
//     // takeLatest(UPDATE_USER, UpdateUser)
//   ]);
// }

// export default User;
